import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationPT from './locales/pt.json';

const resources = {
  es: {
    translation: translationES
  },
  pt: {
    translation: translationPT
  },
  en: {
    translation: translationEN
  }
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'navigator',
        'path',
        'subdomain'
      ],
      caches: ['localStorage', 'cookie']
    }
  });

export default i18n;
